"use strict";

exports.__esModule = true;
exports.getLabelFromProps = getLabelFromProps;

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/nb");

require("moment/locale/nn");

require("moment/locale/sv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLabelFromProps(props) {
  let label = props.label;

  if (!label) {
    return undefined;
  } // get url from urlPattern


  const labelParts = label.split(' ');
  label = labelParts.map(name => {
    let value = name;

    if (name.startsWith(":")) {
      name = name.substr(1);
      value = props[name] || undefined;
    }

    return value;
  });
  return label.join(" ");
}